import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { ProductService } from 'src/app/service/product.service';
import { Category, Product, Talle } from 'src/app/types/types';
import { AngularFireStorage } from '@angular/fire/storage';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-add-product-modal',
  templateUrl: './product-modal.component.html',
  styleUrls: ['./product-modal.component.css']
})
export class ProductModalComponent implements OnInit {
  @Input("update")
  update : any;
  talles : Talle[] = [];
  categories : Category[] = [];
  form : FormGroup;
  path:string;
  imageUploaded :boolean;
  random : number = Math.random();
  constructor(
    private productService : ProductService,
    private af : AngularFireStorage,
    private fb : FormBuilder
  ) {
    this.imageUploaded=false;
    this.path = '';
    this.talles = this.productService.getTalles();
    this.categories = this.productService.getCategories();
   }

   initForm() {
    this.form = this.fb.group({
      name:        new FormControl("" ,[Validators.required]),
      description: new FormControl("",[Validators.required]),
      imgUrl:      new FormControl("",[]),
      price:       new FormControl("",[Validators.required,Validators.min(1)]),
      discount:    new FormControl("",[]),
      category:    new FormControl("Baby",[Validators.required]),
      isVisible :  new FormControl(true,[]),
      isTrending : new FormControl(false,[])
    })
    this.talles.forEach( t => {
        this.form.addControl(t,new FormControl(false))
      });
    this.form.reset({
      name :  ''
    })
   }

   getUrlImage() :string {
    if(this.path) {
      this.uploadImage()
    }
    return this.form.get('imgUrl').value || this.getUrlOfName(this.getNameForFile());
   }

   postForm(){
     if(this.form.invalid || this.invalidTalles || this.invalidImage ){
       console.log("form mal completo")
    }
     else{
      const bodyTalles = this.talles.filter( t => this.form.get(t).value);
      const body : Product = {
        _id:null,
        name:this.form.get('name').value,
        description:this.form.get('description').value,
        imgUrl:this.getUrlImage(),
        price:parseFloat(this.form.get('price').value),
        discount:this.form.get('discount').value,
        talles: bodyTalles,
        category:this.form.get('category').value,
        date : new Date(),
        isTrending : this.form.get('isTrending').value,
        visible : this.form.get('isVisible').value
      }
     this.productService.saveProduct(body).subscribe(() => {
      Swal.fire({
        title:"Agregado!",
        icon:"success"
      }).then( () => this.update());
     });
     }
   }

  ngOnInit(): void {
    this.initForm();
    console.log(this.form);
    
  }

  upload($event) {
    this.path = $event.target.files[0];
  }

  getNameForFile() {
    return this.form.get('name').value + this.random;
  }

  async uploadImage(){
    console.log(this.path)
    let promise = this.af.upload(this.getNameForFile(),this.path);
    let result = await promise;
    console.log(result);
  }

  getUrlOfName(name:string) {
    return `https://firebasestorage.googleapis.com/v0/b/pomelo-bebes.appspot.com/o/${name}?alt=media`
  }

  get invalidImage() {
    return this.path === '' && this.form.get('imgUrl').value === ''
  }

  get invalidName() {
    return this.form.get('name').invalid && this.form.get('name').touched;
  }
  get invalidDescription() {
    return this.form.get('description').invalid && this.form.get('description').touched;
  }
  get invalidPrice() {
    return this.form.get('price').invalid && this.form.get('price').touched;
  }
  get invalidDiscount() {
    return this.form.get('discount').invalid && this.form.get('discount').touched;
  }
  get invalidImgUrl() {
    return this.form.get('imgUrl').invalid && this.form.get('imgUrl').touched && !this.path;
  }
  get invalidCategory() {
    return this.form.get('category').invalid && this.form.get('category').touched;
  }
  get invalidTalles() {
    return this.talles.every( t => ! this.form.get(t).value);
  }
}
